import { combineReducers } from "redux";
import { chartAccountsConstants } from "../../actions/chartAccounts";

function searched(state, { type, payload }) {
  let defaultS = typeof state === "undefined" ? {} : state;
  switch (type) {
  case chartAccountsConstants.GET_SEARCHED_ACCOUNTS_LIST_START:
    return {
      status: {
        started: true,
        error: false,
        ended: false
      }
    };
  case chartAccountsConstants.GET_SEARCHED_ACCOUNTS_LIST_SUCCESS:
    return {
      status: {
        started: false,
        error: false,
        ended: true
      },
      data: payload.data
    };
  case chartAccountsConstants.GET_SEARCHED_ACCOUNTS_LIST_ERROR:
    return {
      status: {
        started: false,
        error: true,
        ended: false
      }
    };
  default:
    return defaultS;
  }
}

export const chartAccounts = combineReducers({
  searched
});

export default chartAccounts;
